<template>
    <el-form :inline="true" :model="queryParam" class="mainSearch">
      <el-form-item label="标题">
        <el-input v-model="queryParam.title" placeholder="新闻标题" />
      </el-form-item>
      <el-form-item label="类型">
          <el-select
            style="width:100%"
            v-model="queryParam.typename"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in newsTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="新闻状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListNews">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <div class="mainTableTop">
          <el-button
            type="primary"
            @click="(dialog = true), doNewsAdd()"
            v-hasPermission="['news:add']"
            >发布新闻</el-button>
        </div>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="typename" label="类型"/>
          <el-table-column prop="sources" label="来源"/>
          <el-table-column prop="viewnum" label="浏览量"/>
          <el-table-column prop="published" label="发布时间"/>
          <el-table-column prop="created" label="创建时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" >
        <template #default="scope">
          <el-tag
            round
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            disable-transitions
            ><span v-text="util.showCommonStatus(scope.row.status)"></span>
          </el-tag>
        </template>
      </el-table-column>
          <el-table-column label="操作" fixed="right" width="160">
            <template #default="scope">
              <el-link
              type="primary"
              @click="(dialog = true), doNewsEdit(scope.$index, scope.row)"
              v-hasPermission="['news:edit']"
              >编辑</el-link>
  
              <el-popconfirm
                confirm-button-type="primary"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon-color="#626AEF"
                title="您确定删除吗？"
                width="200px"
                @confirm="doNewsDelete(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-link
                    type="danger"
                    v-hasPermission="['news:delete']"
                    >删除</el-link
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8">
        <!-- <div>
          <el-button type="primary">发布新闻</el-button>
        </div> -->
      </el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="false"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
    <el-drawer
      ref="drawerRef"
      v-model="dialog"
      :title="title"
      direction="rtl"
      :close-on-click-modal="false"
      size="60%"
      @close="doNewsClose()"
    >
      <div class="common-drawer__content">
        <el-form
          ref="newsFormRef"
          :model="newsForm"
          :rules="rules"
          label-width="120px"
        >
        <el-form-item label="类型" prop="typename">
          <el-select
            style="width:100%"
            v-model="newsForm.typename"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in newsTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
            <el-input
              v-model.trim="newsForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="picture">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              ref="fileUpload1"
              :headers="headerUpload"
              :on-success="doUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/png, image/jpeg, image/jpg"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择图片</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg后缀名且小于1M的文件。
                </div>
              </template>
            </el-upload>
            <el-image v-if="newsForm.picture" style="width: 120px;display: block;" :src="newsForm.picture" />
          </el-form-item>
          <el-form-item label="标签" prop="tag">
            <el-input
              v-model.trim="newsForm.tag"
              placeholder="请输入标签"
            ></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="url">
            <el-input
              v-model.trim="newsForm.url"
              placeholder="请输入URL"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布日期" prop="published">
            <el-date-picker
              v-model="newsForm.published"
              type="date"
              placeholder="请选择发布日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="新闻描述" prop="content">
            <editor ref="editorRef" :content="newsForm.content" @update:content="updateContent"></editor>
          </el-form-item>
          <el-form-item label="新闻附件" prop="attachment">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              :headers="headerUpload"
              :on-success="doUploadSuccess2"
              :before-upload="beforeUpload2"
              multiple
              v-model="fileList"
              ref="fileUpload2"
              accept="image/png, image/jpeg, image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/pdf"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择附件（可多选）</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg、Word、Pdf、Zip后缀名且小于10M的文件。
                 <template  v-for="(item,index) in fileList" :key="index">
                  <div style="cursor: pointer;">
                    <el-link type="primary" @click="doDownload(item.name,item.url)">{{item.name}}</el-link> 
                    <el-icon :size="14" style="vertical-align: -2px; margin-left: 15px;" @click="deleteFileList(index)">
                      <Delete />
                    </el-icon>
                  </div>
                  
                </template>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item label="作者" prop="author">
            <el-input
              v-model.trim="newsForm.author"
              placeholder="请输入作者"
            ></el-input>
          </el-form-item>
          <el-form-item label="来源" prop="sources">
            <el-input
              v-model.trim="newsForm.sources"
              placeholder="请输入来源"
            ></el-input>
          </el-form-item>
          <el-form-item label="权重" prop="weight">
            <el-input
              v-model.trim="newsForm.weight"
              placeholder="请输入权重"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="newsForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="common-drawer__footer">
          <el-button @click="doNewsClose()">关闭</el-button>
          <el-button type="primary" :loading="loading" @click="doNewsSave">{{
            loading ? "提交中 ..." : "提交"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script setup>
  import { ref, onMounted ,defineEmits } from "vue";
  // import { useRouter } from "vue-router";
  import { ElDrawer, ElTable, ElMessage } from "element-plus";
  import { listNews, deleteNews,saveNews  } from "@/api/news";//
  import { downloadFile } from "@/api/common";
  
  import editor from '@/components/common/editor.vue'
  
  import util from "@/util/tool.js";
  // import storage from "@/util/storage.js";
  
  import store from "@/store";

  import config from "@/util/config.js";

  
  let timer;
  
  const dialog = ref(false);
  const loading = ref(false);
  const loadingData = ref(true);
  
  const fileList = ref([])
  const emit = defineEmits(["click"]); // 声明父触发事件
  
  const newsTypeData = config.configNewsTypeData;

  
  // const router = useRouter();
  // let open = (routeName, row) => {
  //   storage.saveSessionObject("newsPath",queryParam.value)
  //   router.push({
  //     name: routeName,
  //     params: { id: row.newsid },
  //     query: { eflag:row.eflag, name: row.name },
  //   });
  // };
  
  const drawerRef = ref(ElDrawer);
  const editorRef = ref()
  
  const tableData = ref();
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  let newsFormRef = ref();
  let title = ref("发布新闻");
  
  // const defaultSelectDepart = ref([])
  
  //onMounted方法
  onMounted(() => {
    getListNews();
  });
  
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    typename:"",
    status: "",
    title: "",
  });
  const resetSearch = () => {
    queryParam.value = {
      pageNo: 1,
      pageSize: pageSize.value,
      typename: "",
      status: "",
      title: "",
    };
    getListNews();
  };
  
  //新闻表单项
  let newsForm = ref({
    newsid: null,
    typename: "",
    title: "",
    picture: "",
    tag: "",
    url: "",
    author: "",
    sources: "",
    weight: "",
    attachment:"",
    content: "",
    status:1,
    published:'',
  });
  
  //发布新闻
  const doNewsAdd = () => {
    title.value = "发布新闻";
    // console.log('add',newsForm.value)
  
    // newsForm.value.content = ''
    // editorRef.value.valueHtml = '<p></p>'
    resetForm();
  };
  
  //编辑新闻
  const doNewsEdit = (index, obj) => {
    title.value = "编辑新闻";

    fileList.value = []
  
    newsForm.value = {
      newsid: obj.newsid,
        typename: obj.typename,
        title: obj.title,
        picture: obj.picture,
        tag: obj.tag,
        url: obj.url,
        author: obj.author,
        sources: obj.sources,
        weight: obj.weight,
        attachment: obj.attachment,
        content: obj.content,
        status: obj.status,
        published: obj.published,
    };
    setTimeout(function(){
    //   startedEnded.value = [util.getFormateDate(obj.started), util.getFormateDate(obj.ended)]
      newsForm.value.typename = obj.typename
      if (obj.attachment) {
        fileList.value = JSON.parse(obj.attachment)
      }
    },400)
  
    // editorRef.value && (editorRef.value.valueHtml && (editorRef.value.valueHtml = newsForm.value.content));
    editorRef.value.valueHtml = newsForm.value.content
  
  };
  const resetForm = () => {
    newsForm.value = {
      newsid: null,
    typename: "",
    title: "",
    picture: "",
    tag: "",
    url: "",
    author: "",
    sources: "",
    weight: "",
    attachment:"",
    content: "",
    status:1,
    published:'',
    };
    fileList.value = []
    // editorRef.value.valueHtml = ''
    editorRef.value && (editorRef.value.valueHtml && (editorRef.value.valueHtml = ''));
  };
  
  
  const updateContent = (e) => {
    newsForm.value.content = e
  }
  
  //关闭新闻表单弹窗
  const doNewsClose = () => {
    loading.value = false;
    dialog.value = false;
    clearTimeout(timer);
    newsFormRef.value.resetFields()
  };
  
  //保存新闻数据
  const doNewsSave = () => {
    newsFormRef.value.validate((valid) => {
      if (!valid) {
        //ElMessage("请先完善表单数据填写！");
        return;
      }
      saveNews(newsForm.value).then((res) => {
        loading.value = true;
        timer = setTimeout(() => {
          // 动画关闭需要一定的时间
          setTimeout(() => {
            loading.value = false;
          }, 400);
          if (res.data.code === 1) {
            getListNews();
            doNewsClose();
          } else {
            ElMessage.error(res.data.msg);
          }
        }, 1000);
      });
    });
  };
  
  //更新新闻状态
  const doNewsDelete = (index, obj) => {
    // console.log('obj.newsid',obj.newsid.toString())
    deleteNews(obj).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        getListNews();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  };
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListNews();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListNews();
  };
  
  //新闻列表API
  const getListNews = () => {
    listNews(queryParam.value).then((res) => {
      tableData.value = res.data.extend.pages.list;
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      loadingData.value = false
    });
  };
  
  //新闻表单验证规则
  const rules = ref({
    typename: [
      {
        required: true,
        message: "请选择新闻类型",
        trigger: "blur",
      },
    ],
    picture: [
      {
        required: true,
        message: "请上传新闻封面",
        trigger: "blur",
      },
    ],
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur",
      },
      {
        min: 2,
        max: 200,
        message: "标题长度2到200",
        trigger: "blur",
      },
    ],
    // content: [
    //   {
    //     required: true,
    //     message: "请输入新闻描述",
    //     trigger: "blur",
    //   },
    // ],
    
  });
  
  
  const filefail = ref("");
  const resultMsg = ref();
  const fileUpload1 = ref();
  const doUploadSuccess = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg.value = response.msg
      filefail.value = response.url
      newsForm.value.picture = response.url
      setTimeout(function(){
        fileUpload1.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload = (rawFile) => {
    if (rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传PNG、JPEG、JPG格式图片!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 1) {
      ElMessage.error('请上传小于1MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  
  const filefail2 = ref("");
  const resultMsg2 = ref();
  const fileUpload2 = ref();
  const doUploadSuccess2 = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg2.value = response.msg
      filefail2.value = response.url
      let obj = {name:response.name,size:response.size,url:response.url,type:response.type}
      fileList.value.push(obj)
      newsForm.value.attachment = JSON.stringify(fileList.value)
      setTimeout(function(){
        fileUpload2.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload2 = (rawFile) => {
    if (rawFile.type !== 'application/msword' && rawFile.type !=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' && rawFile.type !=='application/zip' && rawFile.type !=='application/pdf' && rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传Png、Jpeg、Jpg、Word、Pdf、Zip格式文件!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 10) {
      ElMessage.error('请上传小于10MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  //删除附件
  const deleteFileList = (index) => {
    fileList.value.splice(index,1)
    newsForm.value.attachment = JSON.stringify(fileList.value)
  }
  
  const headerUpload = ref({
    Authorization: store.state.user.token,
  });
  
  const doDownload = (filename, url) => {
    let data = {filename,url}
    downloadFile(data).then((response) => {
      const content = response.data;
      const blob = new Blob([content], {
        type: "application/octet-stream"
      });
      const downloadElement = document.createElement("a");
      const href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = decodeURI(response.headers["filename"]);
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
      emit("click");
    });
  }
  
  </script>
  <style scoped>
  .checkAll {
    padding-left: 20px;
      border-bottom: 1px solid #f4f4f4;
      display: flex;
  }
  </style>
  